<template>
    <NuxtLayout name="malt-base-layout">
        <VJoyFunnel layout-width="medium">
            <template #funnel-header>
                <VJoyFunnelHeader>
                    <template #funnel-header-right>
                        <VJoyIconButton
                            icon="cross"
                            variant="ghost"
                            data-testid="security-check-exit-button"
                            @click="openSecurityCheckDialog = true"
                        />
                    </template>
                </VJoyFunnelHeader>
            </template>
            <div class="security-check">
                <div class="security-check__header">
                    <h1>{{ securityCheckHeader }}</h1>
                    <h2>{{ t('account.security.check.page.subtitle') }}</h2>
                </div>
                <slot />
            </div>
        </VJoyFunnel>
        <SecurityCheckCancelDialog :open="openSecurityCheckDialog" @cancel="openSecurityCheckDialog = false" />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {ref, computed} from 'vue';
    import {useTranslation, useRoute} from '#imports';
    import {VJoyFunnel, VJoyFunnelHeader, VJoyIconButton} from '@maltjoy/core-vue';
    import SecurityCheckCancelDialog from '~/components/SecurityCheckCancelDialog.vue';
    import {usePhoneNumberStore} from '~/store/phone-number.store';
    import {useRedirectParamsStore} from '~/store/redirect-params.store';

    // Stores
    const phoneNumberStore = usePhoneNumberStore();
    const redirectParamsStore = useRedirectParamsStore();
    const {setRedirectUrl} = redirectParamsStore;

    // Composables
    const {t} = useTranslation();
    const route = useRoute();

    // Refs
    const openSecurityCheckDialog = ref<boolean>(false);

    // Computed values
    const securityCheckHeader = computed(() =>
        route.path === '/security-check/two-step-verification'
            ? t('account.security.check.page.two.step.verification.title')
            : t('account.security.check.page.title'),
    );

    // Handlers
    await Promise.all([phoneNumberStore.getPhoneNumber(), phoneNumberStore.getPhoneNumberValidationStatus()]);

    setRedirectUrl();
</script>

<style lang="scss">
    .security-check {
        &__header {
            margin-top: 86px;
            margin-bottom: var(--joy-core-spacing-8);
        }
        h1 {
            font-family: var(--joy-font-family-title);
            font-size: var(--joy-font-size-secondary-200);
            margin: 0;
        }

        h2 {
            font-size: var(--joy-font-size-primary-400);
            font-weight: var(--joy-font-weight-normal);
            letter-spacing: -0.2px;
        }
    }
</style>
